var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-bottom-sheet',{attrs:{"max-width":"998"},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c(_vm.componentComputed,{tag:"component",staticClass:"app-bottom-sheet-root",attrs:{"options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }